(ns scittle.geom
  {:no-doc true}
  (:require [scittle.core :as scittle]
            [sci.core :as sci]
    [thi.ng.geom.aabb]
    [thi.ng.geom.attribs]
    [thi.ng.geom.basicmesh]
    [thi.ng.geom.bezier]
    [thi.ng.geom.circle]
    [thi.ng.geom.core]
    [thi.ng.geom.cuboid]
    [thi.ng.geom.gl.arcball]
    [thi.ng.geom.gl.buffers]
    [thi.ng.geom.gl.camera]
    [thi.ng.geom.gl.core]
    [thi.ng.geom.gl.fx]
    [thi.ng.geom.gl.fx.bloom]
    [thi.ng.geom.gl.glmesh]
    [thi.ng.geom.gl.shaders]
    [thi.ng.geom.gl.shaders.basic]
    [thi.ng.geom.gl.shaders.image]
    [thi.ng.geom.gl.shaders.lambert]
    [thi.ng.geom.gl.shaders.phong]
    [thi.ng.geom.gl.shaders.shadow]
    [thi.ng.geom.gl.shaders.spotlight]
    [thi.ng.geom.gl.shaders.xray]
    [thi.ng.geom.gl.utils]
    [thi.ng.geom.gl.webgl.animator]
    [thi.ng.geom.gl.webgl.constants]
    [thi.ng.geom.gmesh]
    [thi.ng.geom.indexedmesh]
    [thi.ng.geom.line]
    [thi.ng.geom.matrix]
    [thi.ng.geom.mesh.csg]
    [thi.ng.geom.mesh.io]
    [thi.ng.geom.mesh.ops]
    [thi.ng.geom.mesh.subdivision]
    [thi.ng.geom.meshface]
    [thi.ng.geom.path]
    [thi.ng.geom.physics.core]
    [thi.ng.geom.plane]
    [thi.ng.geom.polygon]
    [thi.ng.geom.polyhedra]
    [thi.ng.geom.ptf]
    [thi.ng.geom.quad]
    [thi.ng.geom.quaternion]
    [thi.ng.geom.rect]
    [thi.ng.geom.spatialtree]
    [thi.ng.geom.sphere]
    [thi.ng.geom.svg.adapter]
    [thi.ng.geom.svg.core]
    [thi.ng.geom.svg.renderer]
    [thi.ng.geom.svg.shaders]
    [thi.ng.geom.tetrahedron]
    [thi.ng.geom.triangle]
    [thi.ng.geom.types]
    [thi.ng.geom.utils]
    [thi.ng.geom.utils.delaunay]
    [thi.ng.geom.utils.intersect]
    [thi.ng.geom.utils.subdiv]
    [thi.ng.geom.vector]
    [thi.ng.geom.version]
    [thi.ng.geom.viz.core]
    [thi.ng.geom.voxel.isosurface]
    [thi.ng.geom.voxel.svo]
    [thi.ng.math.core]
    [thi.ng.math.bits]
    [thi.ng.math.gamma]
    [thi.ng.math.noise]
    [thi.ng.color.core]
    [thi.ng.color.gradients]
    [thi.ng.color.presets]))

;; Plugin: geom
;; Generated by build.clj

(defn init []
  (scittle/register-plugin!
   ::geom
   {:namespaces
   {'thi.ng.geom.aabb (sci/copy-ns thi.ng.geom.aabb (sci/create-ns 'thi.ng.geom.aabb nil))
    'thi.ng.geom.attribs (sci/copy-ns thi.ng.geom.attribs (sci/create-ns 'thi.ng.geom.attribs nil))
    'thi.ng.geom.basicmesh (sci/copy-ns thi.ng.geom.basicmesh (sci/create-ns 'thi.ng.geom.basicmesh nil))
    'thi.ng.geom.bezier (sci/copy-ns thi.ng.geom.bezier (sci/create-ns 'thi.ng.geom.bezier nil))
    'thi.ng.geom.circle (sci/copy-ns thi.ng.geom.circle (sci/create-ns 'thi.ng.geom.circle nil))
    'thi.ng.geom.core (sci/copy-ns thi.ng.geom.core (sci/create-ns 'thi.ng.geom.core nil))
    'thi.ng.geom.cuboid (sci/copy-ns thi.ng.geom.cuboid (sci/create-ns 'thi.ng.geom.cuboid nil))
    'thi.ng.geom.gl.arcball (sci/copy-ns thi.ng.geom.gl.arcball (sci/create-ns 'thi.ng.geom.gl.arcball nil))
    'thi.ng.geom.gl.buffers (sci/copy-ns thi.ng.geom.gl.buffers (sci/create-ns 'thi.ng.geom.gl.buffers nil))
    'thi.ng.geom.gl.camera (sci/copy-ns thi.ng.geom.gl.camera (sci/create-ns 'thi.ng.geom.gl.camera nil))
    'thi.ng.geom.gl.core (sci/copy-ns thi.ng.geom.gl.core (sci/create-ns 'thi.ng.geom.gl.core nil))
    'thi.ng.geom.gl.fx (sci/copy-ns thi.ng.geom.gl.fx (sci/create-ns 'thi.ng.geom.gl.fx nil))
    'thi.ng.geom.gl.fx.bloom (sci/copy-ns thi.ng.geom.gl.fx.bloom (sci/create-ns 'thi.ng.geom.gl.fx.bloom nil))
    'thi.ng.geom.gl.glmesh (sci/copy-ns thi.ng.geom.gl.glmesh (sci/create-ns 'thi.ng.geom.gl.glmesh nil))
    'thi.ng.geom.gl.shaders (sci/copy-ns thi.ng.geom.gl.shaders (sci/create-ns 'thi.ng.geom.gl.shaders nil))
    'thi.ng.geom.gl.shaders.basic (sci/copy-ns thi.ng.geom.gl.shaders.basic (sci/create-ns 'thi.ng.geom.gl.shaders.basic nil))
    'thi.ng.geom.gl.shaders.image (sci/copy-ns thi.ng.geom.gl.shaders.image (sci/create-ns 'thi.ng.geom.gl.shaders.image nil))
    'thi.ng.geom.gl.shaders.lambert (sci/copy-ns thi.ng.geom.gl.shaders.lambert (sci/create-ns 'thi.ng.geom.gl.shaders.lambert nil))
    'thi.ng.geom.gl.shaders.phong (sci/copy-ns thi.ng.geom.gl.shaders.phong (sci/create-ns 'thi.ng.geom.gl.shaders.phong nil))
    'thi.ng.geom.gl.shaders.shadow (sci/copy-ns thi.ng.geom.gl.shaders.shadow (sci/create-ns 'thi.ng.geom.gl.shaders.shadow nil))
    'thi.ng.geom.gl.shaders.spotlight (sci/copy-ns thi.ng.geom.gl.shaders.spotlight (sci/create-ns 'thi.ng.geom.gl.shaders.spotlight nil))
    'thi.ng.geom.gl.shaders.xray (sci/copy-ns thi.ng.geom.gl.shaders.xray (sci/create-ns 'thi.ng.geom.gl.shaders.xray nil))
    'thi.ng.geom.gl.utils (sci/copy-ns thi.ng.geom.gl.utils (sci/create-ns 'thi.ng.geom.gl.utils nil))
    'thi.ng.geom.gl.webgl.animator (sci/copy-ns thi.ng.geom.gl.webgl.animator (sci/create-ns 'thi.ng.geom.gl.webgl.animator nil))
    'thi.ng.geom.gl.webgl.constants (sci/copy-ns thi.ng.geom.gl.webgl.constants (sci/create-ns 'thi.ng.geom.gl.webgl.constants nil))
    'thi.ng.geom.gmesh (sci/copy-ns thi.ng.geom.gmesh (sci/create-ns 'thi.ng.geom.gmesh nil))
    'thi.ng.geom.indexedmesh (sci/copy-ns thi.ng.geom.indexedmesh (sci/create-ns 'thi.ng.geom.indexedmesh nil))
    'thi.ng.geom.line (sci/copy-ns thi.ng.geom.line (sci/create-ns 'thi.ng.geom.line nil))
    'thi.ng.geom.matrix (sci/copy-ns thi.ng.geom.matrix (sci/create-ns 'thi.ng.geom.matrix nil))
    'thi.ng.geom.mesh.csg (sci/copy-ns thi.ng.geom.mesh.csg (sci/create-ns 'thi.ng.geom.mesh.csg nil))
    'thi.ng.geom.mesh.io (sci/copy-ns thi.ng.geom.mesh.io (sci/create-ns 'thi.ng.geom.mesh.io nil))
    'thi.ng.geom.mesh.ops (sci/copy-ns thi.ng.geom.mesh.ops (sci/create-ns 'thi.ng.geom.mesh.ops nil))
    'thi.ng.geom.mesh.subdivision (sci/copy-ns thi.ng.geom.mesh.subdivision (sci/create-ns 'thi.ng.geom.mesh.subdivision nil))
    'thi.ng.geom.meshface (sci/copy-ns thi.ng.geom.meshface (sci/create-ns 'thi.ng.geom.meshface nil))
    'thi.ng.geom.path (sci/copy-ns thi.ng.geom.path (sci/create-ns 'thi.ng.geom.path nil))
    'thi.ng.geom.physics.core (sci/copy-ns thi.ng.geom.physics.core (sci/create-ns 'thi.ng.geom.physics.core nil))
    'thi.ng.geom.plane (sci/copy-ns thi.ng.geom.plane (sci/create-ns 'thi.ng.geom.plane nil))
    'thi.ng.geom.polygon (sci/copy-ns thi.ng.geom.polygon (sci/create-ns 'thi.ng.geom.polygon nil))
    'thi.ng.geom.polyhedra (sci/copy-ns thi.ng.geom.polyhedra (sci/create-ns 'thi.ng.geom.polyhedra nil))
    'thi.ng.geom.ptf (sci/copy-ns thi.ng.geom.ptf (sci/create-ns 'thi.ng.geom.ptf nil))
    'thi.ng.geom.quad (sci/copy-ns thi.ng.geom.quad (sci/create-ns 'thi.ng.geom.quad nil))
    'thi.ng.geom.quaternion (sci/copy-ns thi.ng.geom.quaternion (sci/create-ns 'thi.ng.geom.quaternion nil))
    'thi.ng.geom.rect (sci/copy-ns thi.ng.geom.rect (sci/create-ns 'thi.ng.geom.rect nil))
    'thi.ng.geom.spatialtree (sci/copy-ns thi.ng.geom.spatialtree (sci/create-ns 'thi.ng.geom.spatialtree nil))
    'thi.ng.geom.sphere (sci/copy-ns thi.ng.geom.sphere (sci/create-ns 'thi.ng.geom.sphere nil))
    'thi.ng.geom.svg.adapter (sci/copy-ns thi.ng.geom.svg.adapter (sci/create-ns 'thi.ng.geom.svg.adapter nil))
    'thi.ng.geom.svg.core (sci/copy-ns thi.ng.geom.svg.core (sci/create-ns 'thi.ng.geom.svg.core nil))
    'thi.ng.geom.svg.renderer (sci/copy-ns thi.ng.geom.svg.renderer (sci/create-ns 'thi.ng.geom.svg.renderer nil))
    'thi.ng.geom.svg.shaders (sci/copy-ns thi.ng.geom.svg.shaders (sci/create-ns 'thi.ng.geom.svg.shaders nil))
    'thi.ng.geom.tetrahedron (sci/copy-ns thi.ng.geom.tetrahedron (sci/create-ns 'thi.ng.geom.tetrahedron nil))
    'thi.ng.geom.triangle (sci/copy-ns thi.ng.geom.triangle (sci/create-ns 'thi.ng.geom.triangle nil))
    'thi.ng.geom.types (sci/copy-ns thi.ng.geom.types (sci/create-ns 'thi.ng.geom.types nil))
    'thi.ng.geom.utils (sci/copy-ns thi.ng.geom.utils (sci/create-ns 'thi.ng.geom.utils nil))
    'thi.ng.geom.utils.delaunay (sci/copy-ns thi.ng.geom.utils.delaunay (sci/create-ns 'thi.ng.geom.utils.delaunay nil))
    'thi.ng.geom.utils.intersect (sci/copy-ns thi.ng.geom.utils.intersect (sci/create-ns 'thi.ng.geom.utils.intersect nil))
    'thi.ng.geom.utils.subdiv (sci/copy-ns thi.ng.geom.utils.subdiv (sci/create-ns 'thi.ng.geom.utils.subdiv nil))
    'thi.ng.geom.vector (sci/copy-ns thi.ng.geom.vector (sci/create-ns 'thi.ng.geom.vector nil))
    'thi.ng.geom.version (sci/copy-ns thi.ng.geom.version (sci/create-ns 'thi.ng.geom.version nil))
    'thi.ng.geom.viz.core (sci/copy-ns thi.ng.geom.viz.core (sci/create-ns 'thi.ng.geom.viz.core nil))
    'thi.ng.geom.voxel.isosurface (sci/copy-ns thi.ng.geom.voxel.isosurface (sci/create-ns 'thi.ng.geom.voxel.isosurface nil))
    'thi.ng.geom.voxel.svo (sci/copy-ns thi.ng.geom.voxel.svo (sci/create-ns 'thi.ng.geom.voxel.svo nil))
    'thi.ng.math.core (sci/copy-ns thi.ng.math.core (sci/create-ns 'thi.ng.math.core nil))
    'thi.ng.math.bits (sci/copy-ns thi.ng.math.bits (sci/create-ns 'thi.ng.math.bits nil))
    'thi.ng.math.gamma (sci/copy-ns thi.ng.math.gamma (sci/create-ns 'thi.ng.math.gamma nil))
    'thi.ng.math.noise (sci/copy-ns thi.ng.math.noise (sci/create-ns 'thi.ng.math.noise nil))
    'thi.ng.color.core (sci/copy-ns thi.ng.color.core (sci/create-ns 'thi.ng.color.core nil))
    'thi.ng.color.gradients (sci/copy-ns thi.ng.color.gradients (sci/create-ns 'thi.ng.color.gradients nil))
    'thi.ng.color.presets (sci/copy-ns thi.ng.color.presets (sci/create-ns 'thi.ng.color.presets nil))}}
   ))
